module.exports = __webpack_public_path__ + "static/media/students-walking-festival--resized.0b9c4701.jpg";